// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
const missingEnvVars = [
  !SUPABASE_URL ? "VITE_SUPABASE_URL" : null,
  !SUPABASE_PUBLISHABLE_KEY ? "VITE_SUPABASE_PUBLISHABLE_KEY" : null,
].filter((value): value is string => value !== null);

export const supabaseConfigError =
  missingEnvVars.length > 0
    ? `Configuração ausente: ${missingEnvVars.join(", ")}.`
    : null;

const safeSupabaseUrl = SUPABASE_URL || "https://invalid.supabase.local";
const safeSupabasePublishableKey = SUPABASE_PUBLISHABLE_KEY || "invalid-anon-key";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(safeSupabaseUrl, safeSupabasePublishableKey, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
